import React, { useState } from 'react'
import { Accordion, Button, Form } from 'react-bootstrap'
import upload from '../../assets/images/Paper Upload.png'
import { useNavigate } from 'react-router-dom'
import { createManufacturer } from '../../api/context/manufacturer'
import toast from 'react-hot-toast'
import * as yup from 'yup';
import { useFormik } from 'formik';
import imageToBase64 from 'image-to-base64/browser';

const CreateMyProfile = () => {

    const navigate = useNavigate()

    const [selectedFiles, setSelectedFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [update, setUpdate] = useState(false);

    const handleFileChange = (event) => {
        const files = event.target.files;
        setSelectedFiles(files);
    };

    const cancelStore = () => {
        navigate('/my-profile')
    }

    const validationSchema = yup.object().shape({
        storeName: yup
            .string('')
            .required('Store name is required'),
        image: yup
            .string('')
            .required('Image is required'),
        ownerName: yup
            .string('')
            .required('Owner name is required'),
        phoneNumber: yup
            .string('')
            .required('Phone number is required'),
        email: yup
            .string('')
            .required('Email is required'),
        address: yup
            .string('')
            .required('Address is required'),
        state: yup
            .string('')
            .required('State is required'),
        city: yup
            .string('')
            .required('City is required'),
        landmark: yup
            .string('')
            .required('Landmark is required'),
        pan: yup
            .string('')
            .required('Pan is required'),
        gst: yup
            .string('')
            .required('Gst is required'),
        bankName: yup
            .string('')
            .required('Bank name is required'),
        accountType: yup
            .string('')
            .required('Account type is required'),
        accountHolderName: yup
            .string('')
            .required('Accountholder name is required'),
        accountNumber: yup
            .string('')
            .required('Account number name is required'),
        reaccountNumber: yup
            .string('')
            .required('Account number name is required'),
        ifscCode: yup
            .string('')
            .required('IFSC code is required'),
        // storeTimings: yup
        //     .string('')
        //     .required('Store timings is required'),
    });

    const formik = useFormik({
        initialValues: {
            storeName: '',
            image: '',
            // img_view: '',
            ownerName: '',
            phoneNumber: '',
            email: '',
            address: '',
            state: '',
            city: '',
            landmark: '',
            pan: '',
            gst: '',
            bankName: '',
            accountType: '',
            accountHolderName: '',
            accountNumber: '',
            reaccountNumber: '',
            ifscCode: '',
            storeTimings: [
                { day: 'Monday', openingTime: '', closingTime: '' },
                { day: 'Tuesday', openingTime: '', closingTime: '' },
                { day: 'Wednesday', openingTime: '', closingTime: '' },
                { day: 'Thursday', openingTime: '', closingTime: '' },
                { day: 'Friday', openingTime: '', closingTime: '' },
                { day: 'Saturday', openingTime: '', closingTime: '' },
                { day: 'Sunday', openingTime: '', closingTime: '' },
            ]
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            if (values.image == '') {
                delete values.image;
            }
            delete values.img_view;

            delete values.reaccountNumber;
            setLoading(true);
            createManufacturer(values)((response) => {
                if (response && response?.data?.statusCode == 200) {
                    resetForm();
                    toast.success("Store Created Successfully")
                    setUpdate(!update);
                    setLoading(false);
                } else {
                    toast.error(response?.data?.message);
                    setLoading(false);
                }
            })

        },
    });

    const handleImageChange = async (e) => {
        console.log(e);
        const file = e?.target?.files[0];
        const maxSizeInBytes = 2 * 1024 * 1024;

        if (file.size > maxSizeInBytes) {
            toast.error("File size exceeds 2 MB limit", 'error')
            e.target.value = null;
            return;
        }
        const response = await imageToBase64(URL.createObjectURL(file));
        formik.setValues({
            ...formik.values,
            image: response,
            img_view: 'data:image/jpeg;base64,' + response,
        });
    }

    const statusActive = (id) => {


    }

    console.log(formik);

    return (
        <>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0">My Profile</h4>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className='store_details_wrapper'>
                            <div className='form_wrapper'>
                                <Form onSubmit={formik.handleSubmit}>
                                    <h4>Store Details</h4>
                                    <div className='row mb-5'>
                                        <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Store Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='storeName'
                                                    value={formik.values?.storeName}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.storeName && !formik.errors.storeName}
                                                    isInvalid={formik.touched.storeName && !!formik.errors.storeName}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.storeName}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-4'>
                                            <Form.Group controlId="formFileMultiple" className="mb-3">
                                                <Form.Label>Store Image</Form.Label>
                                                <Form.Control
                                                    type="file"
                                                    onChange={handleImageChange}
                                                    isInvalid={formik.touched.image && formik.errors.image}
                                                    error={formik.errors.image}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.image}</Form.Control.Feedback>
                                                {formik.values.img_view &&
                                                    <img src={formik.values.img_view} alt='Category' className='mb-2' height={150} width={150} />
                                                }
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Owner Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='ownerName'
                                                    value={formik.values?.ownerName}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.ownerName && !formik.errors.ownerName}
                                                    isInvalid={formik.touched.ownerName && !!formik.errors.ownerName}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.ownerName}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Phone No.</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='phoneNumber'
                                                    value={formik.values?.phoneNumber}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.phoneNumber && !formik.errors.phoneNumber}
                                                    isInvalid={formik.touched.phoneNumber && !!formik.errors.phoneNumber}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.phoneNumber}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Email Address*</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='email'
                                                    value={formik.values?.email}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.email && !formik.errors.email}
                                                    isInvalid={formik.touched.email && !!formik.errors.email}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.email}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-8'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Address</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='address'
                                                    value={formik.values?.address}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.address && !formik.errors.address}
                                                    isInvalid={formik.touched.address && !!formik.errors.address}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.address}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>State</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='state'
                                                    value={formik.values?.state}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.state && !formik.errors.state}
                                                    isInvalid={formik.touched.state && !!formik.errors.state}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.state}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>City</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='city'
                                                    value={formik.values?.city}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.city && !formik.errors.city}
                                                    isInvalid={formik.touched.city && !!formik.errors.city}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.city}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Landmark</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='landmark'
                                                    value={formik.values?.landmark}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.landmark && !formik.errors.landmark}
                                                    isInvalid={formik.touched.landmark && !!formik.errors.landmark}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.landmark}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className='store_timings_wrapper'>
                                                <h5>Store Timings</h5>
                                                <div className='timings'>
                                                    <p>Monday | 10:00 - 22:00</p>
                                                    <p>Tuesday | 10:00 - 22:00</p>
                                                    <p>Wednesday | 10:00 - 22:00</p>
                                                    <p>Thursday | 10:00 - 22:00</p>
                                                    <p>Friday | 10:00 - 22:00</p>
                                                    <p>Saturday | 10:00 - 22:00</p>
                                                    <p>Sunday | Closed</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className='store_timings_create'>
                                                <Accordion defaultActiveKey="0">
                                                    {formik.values.storeTimings.map((timing, index) => (
                                                        <Accordion.Item key={index} eventKey={index.toString()}>
                                                            <Accordion.Header>
                                                                <div className='status_wrap'>
                                                                    <Form.Check
                                                                        type="switch"
                                                                        id={`custom-switch-${index}`}
                                                                        checked={formik.values.storeTimings[index].isOpen}
                                                                        onChange={() => statusActive(timing?.id)}
                                                                    />

                                                                </div>
                                                                {timing.day}
                                                            </Accordion.Header>
                                                            <Accordion.Body>
                                                                <div className='time_wrapper'>
                                                                    <div className='row align-items-center'>
                                                                        <div className='col-lg-5'>
                                                                            <Form.Group className="mb-3">
                                                                                <input
                                                                                    type="time"
                                                                                    name={`storeTimings.${index}.openingTime`}
                                                                                    className="form-control"
                                                                                    value={formik.values.storeTimings[index].openingTime}
                                                                                    onChange={formik.handleChange}
                                                                                />
                                                                            </Form.Group>
                                                                        </div>
                                                                        <div className='col-lg-2'>
                                                                            <h5>to</h5>
                                                                        </div>
                                                                        <div className='col-lg-5'>
                                                                            <Form.Group className="mb-3">
                                                                                <input
                                                                                    type="time"
                                                                                    name={`storeTimings.${index}.closingTime`}
                                                                                    className="form-control"
                                                                                    value={formik.values.storeTimings[index].closingTime}
                                                                                    onChange={formik.handleChange}
                                                                                />
                                                                            </Form.Group>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Body>
                                                        </Accordion.Item>
                                                    ))}
                                                </Accordion>
                                            </div>
                                        </div>
                                    </div>

                                    <h4>Business Details</h4>
                                    <div className='row mb-5'>
                                        <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>GST</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='gst'
                                                    value={formik.values?.gst}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.gst && !formik.errors.gst}
                                                    isInvalid={formik.touched.gst && !!formik.errors.gst}
                                                    maxLength={15}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.gst}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>PAN</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='pan'
                                                    value={formik.values?.pan}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.pan && !formik.errors.pan}
                                                    isInvalid={formik.touched.pan && !!formik.errors.pan}
                                                    maxLength={10}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.pan}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                    </div>

                                    <h4>Bank Details</h4>
                                    <div className='row mb-5'>
                                        <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Bank Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='bankName'
                                                    value={formik.values?.bankName}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.bankName && !formik.errors.bankName}
                                                    isInvalid={formik.touched.bankName && !!formik.errors.bankName}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.bankName}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Account Type</Form.Label>
                                                <Form.Select
                                                    className='account_type'
                                                    name='accountType'
                                                    value={formik.values.accountType}
                                                    onChange={formik.handleChange}
                                                    isInvalid={formik.touched.accountType && formik.errors.accountType}
                                                    error={formik.errors.accountType}

                                                >
                                                    <option value=''>
                                                        Select
                                                    </option>
                                                    <option value="Savings">Savings</option>
                                                    <option value="Current">Current</option>

                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">{formik.errors.accountType}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Account Holder Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='accountHolderName'
                                                    value={formik.values?.accountHolderName}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.accountHolderName && !formik.errors.accountHolderName}
                                                    isInvalid={formik.touched.accountHolderName && !!formik.errors.accountHolderName}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.accountHolderName}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Account Number</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='accountNumber'
                                                    value={formik.values?.accountNumber}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.accountNumber && !formik.errors.accountNumber}
                                                    isInvalid={formik.touched.accountNumber && !!formik.errors.accountNumber}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.accountNumber}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-8'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Re-enter Account Number </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='reaccountNumber'
                                                    value={formik.values?.reaccountNumber}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.reaccountNumber && !formik.errors.reaccountNumber}
                                                    isInvalid={formik.touched.reaccountNumber && !!formik.errors.reaccountNumber}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.reaccountNumber}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>IFSC Code</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='ifscCode'
                                                    value={formik.values?.ifscCode}
                                                    onChange={formik.handleChange}
                                                    isValid={formik.touched.ifscCode && !formik.errors.ifscCode}
                                                    isInvalid={formik.touched.ifscCode && !!formik.errors.ifscCode}
                                                />
                                                <Form.Control.Feedback type="invalid">{formik.errors.ifscCode}</Form.Control.Feedback>
                                            </Form.Group>
                                        </div>
                                        {/* <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>City</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='title'
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className='col-lg-4'>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Landmark</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='title'
                                                />
                                            </Form.Group>
                                        </div> */}

                                    </div>
                                    <h4>Product Details</h4>
                                    <div className='row mb-5'>
                                        <div className='col-lg-2'>
                                            <Form.Group className="mb-3">
                                                <label htmlFor="fileInput" className="custom-file-upload">
                                                    <img src={upload} className='upload_icon img-fluid' alt='Upload' />
                                                </label>
                                                <input
                                                    id="fileInput"
                                                    className='file_type'
                                                    type="file"
                                                    multiple
                                                    onChange={handleFileChange}
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>

                                    <div className='btn_wrapper'>
                                        <Button className='cancel_btn' onClick={() => cancelStore()}>Cancel</Button>
                                        <Button className='update_btn' type='submit'>Save</Button>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default CreateMyProfile